import React, { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({ 
  title = "Sourov Roy - Software Engineer", 
  description = "Explore my work, ideas, and interests right here.",
  image,
  url,
  type = "website"
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;

    // Remove existing meta tags
    const existingMetaTags = document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]');
    existingMetaTags.forEach(tag => tag.remove());

    // Create and append Open Graph meta tags
    const ogTags = [
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:type', content: type },
      ...(image ? [{ property: 'og:image', content: image }] : []),
      ...(image ? [{ property: 'og:image:type', content: 'image/jpeg' }] : []),
      ...(url ? [{ property: 'og:url', content: url }] : []),
      { property: 'og:site_name', content: 'Sourov Roy' },
    ];

    ogTags.forEach(tag => {
      const meta = document.createElement('meta');
      meta.setAttribute('property', tag.property);
      meta.setAttribute('content', tag.content);
      document.head.appendChild(meta);
    });

    // Add Twitter Card meta tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      ...(image ? [{ name: 'twitter:image', content: image }] : []),
    ];

    twitterTags.forEach(tag => {
      const meta = document.createElement('meta');
      meta.setAttribute('name', tag.name);
      meta.setAttribute('content', tag.content);
      document.head.appendChild(meta);
    });

    // Cleanup function
    return () => {
      const cleanupTags = document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]');
      cleanupTags.forEach(tag => tag.remove());
    };
  }, [title, description, image, url, type]);

  return null;
};

export default SEO;

